import apiFetch from '@wordpress/api-fetch';
import SiteGlobal from './site-global.js';
import Popups from './popups.js';
import { onReady, getData } from './utils.js';

/* eslint no-alert: 0 */

onReady( () => {
	SiteGlobal.bindEvent( 'click', 'button.c-button_icon_thumbs-up', () => {
		const button = event.target.closest( 'button' ) || event.target;
		const comment_id = button.dataset.commentId;
		apiFetch( {
			path: `/mp/v1/comments/${comment_id}/rate`,
			method: 'POST',
			data: {
				rating: 1,
			},
		} ).then( ( response ) => {
			button.querySelector( 'span' ).innerText = response.rating;
		} ).catch( ( error ) => {
			if ( error.data.status === 401 ) {
				Popups.show( {
					isClosable: true,
					type: 'inline',
					src: '#popup-paywall',
					size: 'medium',
					parentClass: 'c-popup_small-padding',
				} );
			} else {
				alert( error.message );
			}
		} );
	} );

	SiteGlobal.bindEvent( 'click', 'button.c-button_icon_thumbs-down', () => {
		const button = event.target.closest( 'button' ) || event.target;
		const comment_id = button.dataset.commentId;
		apiFetch( {
			path: `/mp/v1/comments/${comment_id}/rate`,
			method: 'POST',
			data: {
				rating: -1,
			},
		} ).then( ( response ) => {
			button.querySelector( 'span' ).innerText = response.rating;
		} ).catch( ( error ) => {
			if ( error.data.status === 401 ) {
				Popups.show( {
					isClosable: true,
					type: 'inline',
					src: '#popup-paywall',
					size: 'medium',
					parentClass: 'c-popup_small-padding',
				} );
			} else {
				alert( error.message );
			}
		} );
	} );

	SiteGlobal.bindEvent( 'click', 'button.c-button_icon_exclamation', () => {
		const button = event.target;
		const comment_id = button.dataset.commentId;
		apiFetch( {
			path: `/mp/v1/comments/${comment_id}/report`,
			method: 'POST',
		} ).then( ( response ) => {
			alert( response.message );
		} ).catch( ( error ) => {
			alert( error.message );
		} );
	} );

	const comments_controls = document.querySelectorAll( '.c-comments__filters select' );
	comments_controls.forEach( ( select ) => {
		select.addEventListener( 'change', () => {
			if ( comments_list ) {
				comments_list.innerHTML = '';
				cpage = 0;
				load_comments( post_id );
				return;
			}

			select.form.submit();
		} );
	} );

	const comments_list = document.querySelector( 'ol.c-comments__list' );
	if ( ! comments_list ) {
		return;
	}

	const post_id = comments_list.dataset.postId;
	const comment_count = comments_list.dataset.commentsCount;
	const per_page = 10;
	let cpage = 1;

	async function load_comments( post_id ) {
		cpage++;

		const comments_filters_form = document.querySelector( 'form.c-comments__filters' );
		const data = new FormData( comments_filters_form );
		data.append( 'post_id', post_id );
		data.append( 'cpage', cpage );
		data.append( 'action', 'comments_list' );

		const url = new URL( window.mp.ajax_url );
		url.search = new URLSearchParams( data ).toString();

		const response = await getData( url.toString() );
		const text = await response.text();

		if ( response.status !== 200 ) {
			alert( text );
			return false;
		}
		comments_list.insertAdjacentHTML( 'beforeend', text );
		if ( cpage * per_page >= comment_count ) {
			load_comment_button.hidden = true;
		} else {
			load_comment_button.hidden = false;
		}
		return true;
	}

	const load_comment_button = document.getElementById( 'load-comments' );
	if ( load_comment_button ) {
		load_comment_button.addEventListener( 'click', () => {
			load_comments( post_id );
		} );
	}

	SiteGlobal.bindEvent( 'click', 'button[aria-expanded][aria-controls]', () => {
		const button = event.target;
		const more_el = document.getElementById( button.getAttribute( 'aria-controls' ) );
		const ellipsis_el = button.previousElementSibling;

		more_el.hidden = false;
		button.hidden = true;
		ellipsis_el.hidden = true;
	} );

	SiteGlobal.bindEvent( 'click', '.comment-reply-link', ( event ) => {
		const link = event.target.closest( '.comment-reply-link' );
		const comment_id = link.dataset.commentid;
		const comment_form = document.getElementById( 'commentform' );

		if ( ! comment_form ) {
			return;
		}

		event.preventDefault();

		if ( document.getElementById( 'comment-form-' + comment_id ) ) {
			return;
		}

		const comment_el = link.closest( '.c-comments__body' );
		const form = comment_form.cloneNode( true );
		form.querySelectorAll( 'input[name="comment_parent"]' ).forEach( ( input ) => {
			input.value = comment_id;
		} );
		form.querySelectorAll( '[id]' ).forEach( ( el ) => el.removeAttribute( 'id' ) );
		form.querySelectorAll( 'label[for]' ).forEach( ( el ) => el.removeAttribute( 'for' ) );
		form.querySelector( 'textarea' ).value = '';
		form.id = 'comment-form-' + comment_id;

		comment_el.appendChild( form );
		form.querySelector( 'textarea' ).focus();
	} );

	SiteGlobal.bindEvent( 'click', 'button[data-edit]', () => {
		const button = event.target;
		const comment_id = button.dataset.edit;
		const comment_form = document.getElementById( 'commentform' );

		if ( ! comment_form || document.getElementById( 'comment-edit-form-' + comment_id ) ) {
			return;
		}

		const comment_el = button.closest( '.c-comments__body' );
		const form = comment_form.cloneNode( true );
		form.querySelectorAll( 'input[type="hidden"]' ).forEach( ( input ) => input.remove() );
		form.querySelectorAll( '[id]' ).forEach( ( el ) => el.removeAttribute( 'id' ) );
		form.querySelectorAll( 'label[for]' ).forEach( ( el ) => el.removeAttribute( 'for' ) );

		form.querySelector( 'textarea' ).value = button.dataset.content;
		form.id = 'comment-edit-form-' + comment_id;
		form.dataset.commentId = comment_id;
		form.removeAttribute( 'action' );

		comment_el.appendChild( form );
	} );

	SiteGlobal.bindEvent( 'click', 'button[data-del]', () => {
		const button = event.target;
		const comment_id = button.dataset.del;
		const comment_el = button.closest( '.c-comments__item' );

		apiFetch( {
			path: `/mp/v1/comments/${comment_id}`,
			method: 'DELETE',
		} ).then( ( response ) => {
			comment_el.classList.add( 'is-deleted' );
			alert( response.message );
		} ).catch( ( error ) => {
			alert( error.message );
		} );
	} );

	SiteGlobal.bindEvent( 'submit', 'form[id^="comment-edit-form"]', () => {
		const form = event.target;
		const comment_id = form.dataset.commentId;
		const comment_el = form.closest( '.c-comments__body' );
		const content = form.querySelector( 'textarea' ).value;

		event.preventDefault();

		apiFetch( {
			path: `/mp/v1/comments/${comment_id}`,
			method: 'POST',
			data: {
				content,
			},
		} ).then( ( response ) => {
			const edit_button = comment_el.querySelector( 'button[data-edit]' );
			if ( edit_button ) {
				edit_button.dataset.content = response.content;
			}
			comment_el.querySelector( '.c-comments__content' ).innerText = response.content;
			form.remove();
			alert( response.message );
		} ).catch( ( error ) => {
			alert( error.message );
		} );
	} );

	const buttons_to_hide = document.querySelectorAll( 'button[data-timeout]' );
	buttons_to_hide.forEach( function( button ) {
		const timeout = parseInt( button.dataset.timeout, 10 );
		setTimeout( () => {
			button.parentNode.removeChild( button );
		}, timeout );
	} );

	SiteGlobal.bindEvent( 'click', '.c-comments__answer a', async () => {
		const link = event.target;
		let target_el = document.querySelector( link.hash );
		if ( target_el ) {
			return true;
		}

		event.preventDefault();

		while ( ! target_el && load_comment_button && ! load_comment_button.hidden ) {
			await load_comments( post_id );
			target_el = document.querySelector( link.hash );
		}

		document.location.hash = link.hash;
	} );
} );
